/**
 * ドメイン型定義（ガイドライン v7 の用語に対応）
 *
 * 時刻はすべて「その日の00:00からの経過分」で表す。跨日は 25:00 → 1500 のように 1440 を超える値。
 */
/** 日種別（セイスイカレンダー由来）。給与計算上は法定休日以外の休日をまとめて所定休日として扱う */
export const DAY_TYPES = ['平日', '所定休日', '法定休日', '祝日', '計画付与', '年末年始'];
/** 休日扱いとなる日種別（GAS HOLIDAY_TYPES と同一） */
export const HOLIDAY_DAY_TYPES = [
    '所定休日',
    '法定休日',
    '祝日',
    '計画付与',
    '年末年始',
];
/** 勤務種別（日報 D列のプルダウン） */
export const WORK_TYPES = [
    '出勤',
    '休日出勤',
    '有休',
    '時間年休',
    '欠勤',
    '振替休日',
    '代休',
];
/** 実際に勤務した扱いとなる勤務種別 */
export const WORKED_TYPES = ['出勤', '休日出勤'];
export const WORK_PATTERN_LABELS = {
    A: '通常勤務',
    B: '出社・直帰',
    C: '直行・直帰',
    D: '直行・帰社',
    E: '移動のみ',
};
/** 休日出勤の取扱い（日報 T列） */
export const HOLIDAY_WORK_TREATMENTS = [
    '振替休日取得（事前指定）',
    '代休取得予定',
    '残業手当希望',
];
//# sourceMappingURL=types.js.map